import { ChangeEvent, Dispatch, SetStateAction } from "react";

import { FieldValues, useForm } from "react-hook-form";

import SearchAddress from "../../../../common/components/form/SearchAddress";
import { RequiredInput } from "../../../../common/components/FormError";
import { IAddress } from "../../../building/interfaces";
import { IDwellingAddress } from "../../interfaces";


export interface AddressFormProps {
  defaultAddress?: string;
  address: IAddress;
  dwellingAddress: IDwellingAddress;
  setAddress: Dispatch<SetStateAction<IAddress>>;
  setDwellingAddress: Dispatch<SetStateAction<IDwellingAddress>>;
}

const AddressForm = ({
  address,
  dwellingAddress,
  setAddress,
  setDwellingAddress,
  defaultAddress,
}: AddressFormProps) => {
  const { control } = useForm<FieldValues>();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    setAddress({
      ...address,
      [name]: value,
    });
  };
  const handleAddressField = (addressField: IAddress) => {
    setAddress({
      ...address,
      address: addressField.address,
      city: addressField.city,
      latitudeY: addressField.latitudeY,
      longitudeX: addressField.longitudeX,
      zip: addressField.zip,
    });
  };

  const handleChangeDwellingAddress = (
    event: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.currentTarget;
    setDwellingAddress({
      ...dwellingAddress,
      [name]: value,
    });
  };

  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex flex-wrap gap-3">
        <div
          className="d-flex flex-column"
          style={{ flex: 1, minWidth: "100px" }}
        >
          <SearchAddress
            control={control}
            name={"address"}
            rules={{ required: "veuillez indiquer une adresse" }}
            label="Adresse postale"
            defaultAddress={defaultAddress || ""}
            isDisabled={false}
            onChangeCallback={handleAddressField}
          />
        </div>
        <div className="d-flex flex-column">
          <label className="add-prop-label" style={{ minWidth: "300px" }}>
            Complément d'adresse :
          </label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="additionalAddress"
            value={address.additionalAddress || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="d-flex flex-wrap gap-3">
        <div
          className="d-flex flex-column"
          style={{ width: window.innerWidth >= 768 ? "300px" : "100%" }}
        >
          <label className="add-prop-label ms-2">Nom de la résidence :</label>
          <input
            className="add-prop-input"
            type="text"
            name="residenceName"
            value={address.residenceName || ""}
            onChange={handleChange}
          />
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: window.innerWidth >= 768 ? "150px" : "100%" }}
        >
          <label className="add-prop-label ms-2">Bâtiment :</label>
          <input
            className="add-prop-input"
            type="text"
            name="buildingNumber"
            value={dwellingAddress.buildingNumber}
            onChange={handleChangeDwellingAddress}
          />
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: window.innerWidth >= 768 ? "75px" : "100%" }}
        >
          <label className="add-prop-label ms-2">
            Niveau : <RequiredInput />
          </label>
          <input
            className="add-prop-input"
            type="text"
            name="floor"
            value={dwellingAddress.floor || ""}
            onChange={handleChangeDwellingAddress}
          />
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: window.innerWidth >= 768 ? "100px" : "100%" }}
        >
          <label className="w-100 add-prop-label ms-2">Entrée :</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="entrance"
            value={dwellingAddress.entrance}
            onChange={handleChangeDwellingAddress}
          />
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: window.innerWidth >= 768 ? "100px" : "100%" }}
        >
          <label className="w-100 add-prop-label ms-2">Porte :</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="door"
            value={dwellingAddress.door}
            onChange={handleChangeDwellingAddress}
          />
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: window.innerWidth >= 768 ? "150px" : "100%" }}
        >
          <label className="w-100 add-prop-label ms-2">Réf Cadastrale :</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            name="cadastralReference"
            value={dwellingAddress.cadastralReference}
            onChange={handleChangeDwellingAddress}
          />
        </div>
      </div>
    </div>
  );
};
export default AddressForm;
